<ion-content>
  <div class="heading-login ion-padding"
    [ngClass]="{
      'bg-partners': isCordova && packageName === 'gospread.partners.tech.app',
      'bg-drivers': isCordova && packageName === 'gospread.tech.app',
      'bg-pwa': !isCordova,
      'ios': isIos
    }">
    <ion-img
      [src]="packageName === 'gospread.partners.tech.app'
        ? 'assets/images/logos/gospread-partners.png'
        : 'assets/images/logos/gospread.png'"
      class="brand" />
    <h1 class="title">
      GoSpread
    </h1>
    <p>Sign in to your account</p>
  </div>
  <div class="login-form">
    <div class="form-container">
      <form [formGroup]="loginForm" (keyup.enter)="tryLogin()">
      <div class="login-field">
        <ion-icon name="mail" class="login-field__icon"></ion-icon>
        <input class="login-field__input" type="email" placeholder="Email" formControlName="email" autocomplete="email" />
      </div>
      <app-field-validator [fieldControl]="loginForm.controls['email']"></app-field-validator>

      <div class="login-field">
        <ion-icon name="key" class="login-field__icon"></ion-icon>
        <input class="login-field__input" [type]="visiblePassword ? 'text': 'password'" placeholder="Password"
          formControlName="password" autocomplete="current-password" />
        <button class="login-field__toggle" (click)="visiblePassword = !visiblePassword" type="button">
          <ion-icon [name]="visiblePassword ? 'eye-off': 'eye'"></ion-icon>
        </button>
      </div>
      <app-field-validator [fieldControl]="loginForm.controls['password']"></app-field-validator>

      <button class="button-bigger" [disabled]="loginForm.invalid" type="submit" (click)="tryLogin()">
        SIGN IN
      </button>

      <footer class="login-footer">
        <a class="login-footer__link" (click)="openModal()">Forgot your password?</a>
        <a class="login-footer__link" routerLink="/register">Sign Up</a>
      </footer>
    </form>
  </div>
</div>
</ion-content>
